const refs = 'payment'
export default [
    {
        path: '/',
        redirect: "/home"
    },
    {
        path: '/payment/:code',
        name: 'payment',
        component: () => import('@/views/'+refs+'/index.vue')
    },
]
